export default "__VITE_ASSET__CNsvFo0r__"